/**
 * colorGridData 
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */
import { getColorUtils } from "./colorUtils";

const mainColors = [
	"#2db8ec",
	"#1E6CF5",
	"#4D32AB",
	"#963BB7",
	"#B5335F",
	"#FB4330",
	"#FB6B30",
	"#FBAA3B",
	"#FBC540",
	"#FFF761",
	"#D9E758",
	"#7AB84F"
];

const mainColorsRgb = mainColors.map((color) => getColorUtils(color).toRgb());

const colCount = mainColors.length;
const rowCount = 10;
const mainRowIndex = Math.floor(rowCount / 2);
const darkerRowsCount = mainRowIndex;
const lighterRowsCount = rowCount - darkerRowsCount - 1;

const monochromatics = [];

const grayscale = [
	...getColorUtils("#000")
		.monochromatic(colCount - 1)
		.map((color) => color.toHexString()),
	"#ffffff"
].reverse();

for (let i = 0; i < rowCount; i++) {
	if (i === mainRowIndex) {
		monochromatics[i] = [ ...mainColors ];
		continue;
	}

	monochromatics[i] = [];
	const darker = i < mainRowIndex;

	for (let j = 0; j < colCount; j++) {
		const mainColor = mainColorsRgb[j];

		if (darker) {
			const rstep = mainColor.r / (darkerRowsCount + 1);
			const gstep = mainColor.g / (darkerRowsCount + 1);
			const bstep = mainColor.b / (darkerRowsCount + 1);

			const r = (i + 1) * rstep;
			const g = (i + 1) * gstep;
			const b = (i + 1) * bstep;

			monochromatics[i][j] = `rgb(${r}, ${g}, ${b})`;
			continue;
		}

		const intensity = i - darkerRowsCount;
		const rstep = (255 - mainColor.r) / (lighterRowsCount + 1);
		const gstep = (255 - mainColor.g) / (lighterRowsCount + 1);
		const bstep = (255 - mainColor.b) / (lighterRowsCount + 1);
		const r = mainColor.r + intensity * rstep;
		const g = mainColor.g + intensity * gstep;
		const b = mainColor.b + intensity * bstep;

		monochromatics[i][j] = `rgb(${r}, ${g}, ${b})`;
	}
}

const colorGridData = [ ...monochromatics, grayscale ];

export { colorGridData };
